import { motion } from "framer-motion";
import { Leaf, Zap, HeartPulse } from "lucide-react";

const BENEFITS = [
  {
    icon: Leaf,
    color: "#7ED321",
    title: "Nutrients Locked In",
    body: "Cold pressing uses no heat, so vitamins, enzymes and minerals stay alive in every bottle.",
  },
  {
    icon: Zap,
    color: "#FF7A1A",
    title: "More Juice, Less Waste",
    body: "Hydraulic pressing extracts up to 5x more from the fruit — you drink the good stuff, not water.",
  },
  {
    icon: HeartPulse,
    color: "#FF3D68",
    title: "Easy on Your Body",
    body: "Pre-broken-down nutrients absorb fast, giving you clean energy without the crash.",
  },
];

const WhyColdPressed = () => (
  <section id="why" className="relative py-20 sm:py-28 scroll-mt-20" data-testid="why-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="mb-12 max-w-2xl"
      >
        <span className="font-display font-extrabold text-[#7ED321] text-sm tracking-[0.2em] uppercase">04 — Why Cold Pressed</span>
        <h2 className="mt-3 font-display font-extrabold text-4xl sm:text-5xl tracking-tight text-[#1A1A1A]">
          The difference you can <span className="text-[#7ED321]">actually taste</span>
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {BENEFITS.map((b, i) => {
          const Icon = b.icon;
          return (
            <motion.div
              key={b.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.55, delay: i * 0.12 }}
              className="relative bg-white rounded-3xl p-8 border border-[#1A1A1A]/5 shadow-[0_10px_30px_rgba(26,26,26,0.06)] hover:-translate-y-1 transition-transform duration-300"
              data-testid={`benefit-card-${i}`}
            >
              <div
                className="w-16 h-16 rounded-2xl flex items-center justify-center mb-6"
                style={{ backgroundColor: `${b.color}20` }}
              >
                <Icon className="w-8 h-8" style={{ color: b.color }} />
              </div>
              <h3 className="font-display font-extrabold text-2xl text-[#1A1A1A]">{b.title}</h3>
              <p className="mt-3 text-[#1A1A1A]/70 leading-relaxed">{b.body}</p>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);

export default WhyColdPressed;
